import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class MobileDeliverSoldVehicleService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  
  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }
  
 /**
  * Get all spare parts
  * @returns Observable<ApiResponse>
  */
  getVehicleSpareParts(): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/spare-parts`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Deliver sold vehicle
   * @param vehicleId
   * @param chassisNo
   * @param selectedSpareParts
   * @param customerName
   * @param customerIDNumber
   * @param customerPhoneNumber
   * @param customerAddress
   * @param transferReason
   * @param locationId
   * @param transferTo
   * @param hasExternalDamage
   * @param comment
   * @param userId
   * @returns
   */
  deliver(vehicleId: string, chassisNo: string, selectedSpareParts: any[],customerName:string,customerIDNumber:string,customerPhoneNumber:string,customerAddress:string,transferReason:string,locationId:string,transferTo:string,hasExternalDamage:boolean,comment: string|null,userId:string): Observable<any> {

    let apiURL:string=`${this.baseURL}/v1/transfer-deliver-sold-vehicle`;

    const data = {
      vehicle_id: vehicleId,
      chassis_no:chassisNo,
      selected_spare_parts: selectedSpareParts,
      customer_name:customerName,
      id_no:customerIDNumber,
      phone_no:customerPhoneNumber,
      customer_address:customerAddress,
      location_id:locationId,
      to_location:transferTo,
      transfer_reason:transferReason,
      comment:comment,
      user_id:userId,
      has_external_damage:hasExternalDamage
    };

    return this.http.post<any>(apiURL, data);
  }
}
